// Сокет чатов: wss://<сервер API>/ws/chat (сервер — chat.js в бэкенде upmob).
// Вход — первым сообщением (токен не попадает в адрес и логи сервера),
// переподключение с нарастающей паузой, пинг раз в 25 секунд (мобильные сети
// и прокси рвут «тихие» соединения). Пока сокета нет, страницы чатов сами
// раз в несколько секунд спрашивают сервер — см. onState.

const DELAYS = [1000, 2000, 5000, 10000, 20000, 30000];

// apiUrl: «https://www.upmob.ru/api/»; getAuth: () => { role, token, … } или null
export function createChatSocket({ apiUrl, getAuth }) {
    const url = String(apiUrl).replace(/^http/, 'ws').replace(/\/api\/?$/, '') + '/ws/chat';
    const listeners = new Set();
    const stateListeners = new Set();
    let ws = null;
    let closed = false;
    let attempt = 0;
    let timer = null;
    let state = 'connecting';

    const setState = (next) => {
        if (state === next) return;
        state = next;
        stateListeners.forEach((fn) => fn(state));
    };

    const schedule = () => {
        if (closed) return;
        clearTimeout(timer);
        timer = setTimeout(connect, DELAYS[Math.min(attempt, DELAYS.length - 1)]);
        attempt++;
    };

    function connect() {
        if (closed || ws) return;
        const auth = getAuth();
        if (!auth || typeof WebSocket === 'undefined') { schedule(); return; }
        let socket;
        try {
            socket = new WebSocket(url);
        } catch (e) {
            schedule();
            return;
        }
        ws = socket;
        socket.onopen = () => {
            try { socket.send(JSON.stringify(Object.assign({ type: 'auth' }, auth))); } catch (e) { /* закроется */ }
        };
        socket.onmessage = (event) => {
            let msg;
            try { msg = JSON.parse(event.data); } catch (e) { return; }
            if (!msg || typeof msg !== 'object') return;
            if (msg.type === 'ready') { attempt = 0; setState('online'); }
            listeners.forEach((fn) => { try { fn(msg); } catch (e) { /* обработчик страницы */ } });
        };
        socket.onclose = (event) => {
            if (ws === socket) ws = null;
            setState('offline');
            // открыто слишком много вкладок — эта (самая старая) ждёт, пока на неё вернутся
            if (event && event.code === 4008) return;
            // вход не принят (вышли из кабинета) — не стучимся каждую секунду
            if (event && (event.code === 4003 || event.code === 4001)) attempt = Math.max(attempt, 4);
            schedule();
        };
        socket.onerror = () => { /* следом придёт onclose */ };
    }

    const ping = setInterval(() => {
        if (ws && ws.readyState === 1) {
            try { ws.send('{"type":"ping"}'); } catch (e) { /* закроется */ }
        }
    }, 25000);

    // вкладка снова на экране или вернулась сеть — переподключиться сразу
    const wake = () => {
        if (closed || ws) return;
        attempt = 0;
        clearTimeout(timer);
        connect();
    };
    const onVisible = () => { if (!document.hidden) wake(); };
    window.addEventListener('online', wake);
    document.addEventListener('visibilitychange', onVisible);

    connect();

    return {
        on(fn) {
            listeners.add(fn);
            return () => listeners.delete(fn);
        },
        onState(fn) {
            stateListeners.add(fn);
            fn(state);
            return () => stateListeners.delete(fn);
        },
        isOnline: () => state === 'online',
        reconnect() {
            if (ws) { try { ws.close(); } catch (e) { /* уже закрыт */ } }
            wake();
        },
        close() {
            closed = true;
            clearTimeout(timer);
            clearInterval(ping);
            window.removeEventListener('online', wake);
            document.removeEventListener('visibilitychange', onVisible);
            if (ws) { try { ws.close(); } catch (e) { /* уже закрыт */ } }
            ws = null;
        }
    };
}
